import { render, staticRenderFns } from "./monthReview.vue?vue&type=template&id=543cd3c6&scoped=true&"
import script from "./monthReview.vue?vue&type=script&lang=ts&"
export * from "./monthReview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543cd3c6",
  null
  
)

export default component.exports